module.exports = __webpack_public_path__ + "img/1515571894921002.f0e3acfa.jpg";